// extracted by mini-css-extract-plugin
module.exports = {"farming":"farming_farming__vmDfP","wrapper":"farming_wrapper__1191d","heading":"farming_heading__1UZ06","Cards":"farming_Cards__oTsAV","card":"farming_card__2ug9b"};